import resume from '../assets/pdf/Lovkash_garg_Resume.pdf'
import lovkashGarg from './Lovkash_garg-preview.png'

export const headerData = {
    name: 'Lovkash garg',
    title: "Software Developer",
    desciption:"IIIT Pune '2026 | Knight @Leetcode | 3 ⭐ Codechef | Finalist UBS-Hackathon 2025 | Finalist PRAXIS-BlueBit 2024 | GSSOC Contributor | Full Stack Developer | Placement Coordinator @IIIT Pune | Web developer @Ecell IIIT Pune",
    image: lovkashGarg,
    resumePdf: resume
}
